import * as React from 'react';
import './schemaModal.scss';
import { Modal } from 'rcd-cpp-ui/ui/modal/Modal';
import { Buttons } from 'rcd-cpp-ui/ui/button/Buttons';
import { Cancel, Primary } from 'rcd-cpp-ui/ui/button';
import { Alert } from '../Alert/alert';
import { Loader } from '../Loader/loader';
import { useActions } from './schemaModalActions';
import { Page } from '../../enums/Page';
import { Configure, Manage, Setup } from '../Icon/icon';
import { PageSetup } from './PageSetup/pageSetup';
import { ModalNav } from '../ModalNav/modalNav';
import { PageFields } from './PageFields/pageFields';
import { D3Schema } from './D3Schema/d3Schema';
import { getSchema } from '../../utils';
import { useSelector } from '../../utils/useSelector';
import { NodeType } from '../../enums/NodeType';
import { PageItemFields } from './PageItemFields/pageItemFields';
import { PageManage } from './PageManage/pageManage';

export const Pages = [
  { label: Page.Setup, Icon: Setup },
  { label: Page.Configure, Icon: Configure },
  { label: Page.Manage, Icon: Manage }
];

export const SchemaModal = () => {
  const page = useSelector(s => s.schemaModal?.page);
  const nodeType = useSelector(s => s.schemaModal?.nodeType);
  const name = useSelector(
    s =>
      getSchema(s.planning?.selectedWorkspace?.schemas, s.schemaModal?.nodeType)
        ?.props?.name || 'Custom Data Type'
  );
  const { closeSchemaModal, save, goToPage, prevPage, nextPage } = useActions();
  if (!page) return null;
  return (
    <Modal
      id="schemaModal"
      header={(!nodeType ? 'Add New ' : 'Edit ') + name}
      onClose={closeSchemaModal}
      footer={
        <Buttons>
          <D3Schema />
          <Cancel onClick={closeSchemaModal} />
          {nodeType != NodeType.Item && page != Page.Configure && (
            <Primary label="Continue" onClick={nextPage} />
          )}
          {nodeType === NodeType.Item && page != Page.Manage && (
            <Primary label="Continue" onClick={nextPage} />
          )}
          {(page == Page.Configure || !!nodeType) && (
            <Primary label={nodeType ? 'Save' : 'Create'} onClick={save} />
          )}
        </Buttons>
      }
    >
      <div className="plan-modal modal-with-nav">
        <Loader id="schemaModalLoader" />
        <Alert id="schemaModalAlert" />
        <ModalNav
          selectedPage={page}
          pages={Pages.filter(page =>
            nodeType != NodeType.Item ? page.label != Page.Manage : true
          )}
          goToPage={p => goToPage(p.label)}
          prevPage={prevPage}
        />
        <div>
          {page == Page.Setup && <PageSetup />}
          {page == Page.Configure &&
            (nodeType === NodeType.Item ? <PageItemFields /> : <PageFields />)}
          {page == Page.Manage && <PageManage />}
        </div>
      </div>
    </Modal>
  );
};
